import {combineReducers} from 'redux';
import {
  registerPollsListener as pollsListener,
  deregisterPollsListener as deregPollsListener,
  setPollResponse,
} from '../module/API';
import {getItem} from '../module/LocalStorage';
import config from '../config/core.json';
import {networkStatusSelector} from './index';

const immutableUpdate = (object, path = "", newValue) => {
  let newObj = {...object}, pathName;
  let currObj = newObj;
  const paths = path.split(".");

  if ( paths.length ) {

    // go through all except the last pathname
    while ( paths.length > 1 ) {
      pathName = paths[0];

      // make new objects for each level in the path, spreading the other properties as we go
      if ( typeof currObj[pathName] === "object" ) {
        currObj[pathName] = {
          ...currObj[pathName]
        }
      } else {
        currObj[pathName] = {};
      }

      currObj = currObj[pathName];
      paths.shift();
    }

    // finally make the mutation
    currObj[paths[0]] = newValue;

  }

  return newObj;
};

// *** REDUCERS

const dataReducer = (state = {}, action) => {

  switch(action.type) {

    case 'DATA_FETCHED':
      if ( action.data && action.data.polls ) {
        return {
          ...action.data.polls,
        }
      } else {
        return state;
      }

    case 'POLLS_UPDATED':
      return {
        ...action.polls,
      };

    default:
      return state;

  }

};

const pollResponsesReducer = (state = {}, action) => {

  let responses;

  switch(action.type) {

    case 'POLLS_UPDATED':
      responses = {};
      if ( action.polls ) {
        Object.keys(action.polls).forEach(pollId => {
          responses[pollId] = action.polls[pollId].responses;
        });
      }
      return responses;

    case 'RESPOND_POLL_CHOICE':
      return immutableUpdate(state, `${action.pollId}.${action.userId}.${action.choiceId}`, action.response);

    default:
      return state;

  }

};

const loadingReducer = (state = false, action) => {

  switch(action.type) {

    case 'START_POLLS_FETCH':
      return true;

    case 'POLLS_UPDATED':
      return false;

    default:
      return state;

  }

};

// *** MAIN REDUCER

export default combineReducers({
  data: dataReducer,
  responses: pollResponsesReducer,
  loading: loadingReducer
});

// *** SELECTORS

export const pollsSelector = (state) => state.data;
export const pollsLoadingSelector = (state) => state.loading;
export const pollSelector = (state, pollId) => pollsSelector(state)[pollId];
export const pollResponsesSelector = (state, pollId) => state.responses[pollId];

// *** ACTIONS

export const respondToPollChoice = ({pollId, choiceId, userId, response}) => {
  return (dispatch) => {
    // optimistically update the state
    dispatch({
      type: "RESPOND_POLL_CHOICE",
      pollId,
      choiceId,
      response,
      userId,
    });

    // then fire off an action, and let the listener update the state
    return setPollResponse(pollId, choiceId, userId, response);

  };
};

export const registerPollsListener = (stag) => {
  let stagData, timeoutId;
  return (dispatch, getState) => {
    // the first time, set a fetching state
    dispatch({
      type: 'START_POLLS_FETCH'
    });
    if ( !networkStatusSelector(getState()) ) {
      stagData = getItem(config.localStorageKey + "_" + stag);
      if ( stagData && stagData.length ) {
        stagData = JSON.parse(stagData);
        if ( stagData && stagData.polls ) {
          dispatch({
            type: 'POLLS_UPDATED',
            polls: stagData.polls,
          });
        }
      }
      timeoutId = window.setTimeout(() => {
        dispatch({
          type: 'POLLS_UPDATED',
          polls: null,
        });
      }, config.requestTimeoutLimitMs);
    }
    return pollsListener(polls => {
      if ( timeoutId ) window.clearTimeout(timeoutId);
      dispatch({
        type: 'POLLS_UPDATED',
        polls
      })
    }, stag);
  };
};

export const deregisterPollsListener = (fn, stag) => dispatch => deregPollsListener(fn, stag);



// WEBPACK FOOTER //
// ./src/reducers/pollsReducer.js